<div class="flex flex-col gap-y-4">
	<app-leap-accounting-items-table
		class="col-span-2"
		title="Legal fees"
		[hst]="hst$ | async"
		[hstTotal]="(totals$ | async)?.feesHST"
		[items]="leapConvenyancingFeeItems$ | async"
	></app-leap-accounting-items-table>
	<app-leap-accounting-items-table
		class="col-span-2"
		title="HST disbursements"
		activityCodeColumnTitle="Recovery Code"
		[hst]="hst$ | async"
		[hstTotal]="(totals$ | async)?.HSTDisbursementsHST"
		[items]="leapHstItems$ | async"
		[feeMode]="false"
	></app-leap-accounting-items-table>
	<app-leap-accounting-items-table
		class="col-span-2"
		title="Non HST disbursements"
		activityCodeColumnTitle="Recovery Code"
		[items]="leapNonHstItems$ | async"
		[feeMode]="false"
	></app-leap-accounting-items-table>
</div>
